import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";

import { DefaultResponseWithData } from "../models/system";
import { IMechanicDamageReport } from "../models/stats/IMechanicDamageReport";

/**
 * from and to are the days picked (yyyy-MM-dd), both included. The response's own `to` is the
 * exclusive end the API worked to - the day after.
 */
export default function useMechanicDamageReport(from: string, to: string) {
  const { get } = useApiHelper();

  const report = useQuery({
    queryKey: ["stats", "damage-by-mechanic", from, to],
    queryFn: () => get<DefaultResponseWithData<IMechanicDamageReport>>(`/stats/damage-by-mechanic?from=${from}&to=${to}`),
    enabled: !!from && !!to && from <= to,
  });

  return {
    report,
  };
}
